import { DispatchShell } from "./dispatch-shell";

/**
 * Dispatch entry route. Real UI lives in DispatchShell, which switches
 * between Day and Week views via the ?view= query param. The standalone
 * /dispatch/map and /dispatch/route-planner pages remain as deep links
 * accessible from the shell header.
 */
export default function DispatchPage() {
    return <DispatchShell initialMode="day" />;
}
